import { atom } from "recoil";

let today = new Date();

export const dateRangeRecoil = atom({
    key: "dateRangeRecoil",
    default: [
        {
            startDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30),
            endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59),
            key: 'selection',
        },
    ],
});

export const defaultDateRangeRecoil = atom({
    key: "defaultDateRangeRecoil",
    default: [
        {
            startDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30),
            endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59),
            key: 'selection',
        },
    ],
});

export const showDashboardDateResetButton = atom({
    key: "showDashboardDateResetButton",
    default: false,
});

export const addDateFilterRecoil = atom({
    key: "addDateFilter",
    default: false,
});

export const isDefaultDateRangeRecoil = atom({
    key: "isDefaultDateRangeRecoil",
    default: true,
});